import React from "react";
import AppSidebar from "./AppSidebar";
import {
  faHome, faTable, faMessage, faFileLines, faFilter,
} from "@fortawesome/free-solid-svg-icons";

const NAV_ITEMS = [
  { href: "/home",      label: "Home",     icon: faHome,      exact: true },
  { href: "/cross-tab", label: "CrossTab", icon: faTable },
  { href: "/chatbot",   label: "ChatBot",  icon: faMessage },
  { href: "/norms",     label: "Norms",    icon: faFileLines },
  { href: "/filters",   label: "Filters",  icon: faFilter },
];

export default function SideNavbarNew() {
  return <AppSidebar navItems={NAV_ITEMS} />;
}
